<template>
	<StandardModal
		open
		small
		class="announcement-type-modal"
		:title="$t('announcements_new_title')"
		:confirmText="$t('common_button_continue')"
		:confirmProps="{ disabled: !type }"
		hideCancel
		@confirm="onContinue"
		@cancel="onClose"
		:tabOrder="[{ all: '.announcement-type', clickOnEnter: true }]"
	>
		<div class="announcement-type-content">
			<div
				class="announcement-type-heading"
				v-t="'announcements_type_main_title'"
			/>
			<div class="announcement-types">
				<div
					class="announcement-type"
					:class="{ active: type === types.ORG }"
					@click="type = types.ORG"
				>
					<ProfilePic :user="org" size="30px" />
					<div class="announcement-type-details">
						<div
							class="announcement-type-title"
							v-text="$t('announcements_type_org_title')"
						/>
						<div class="announcement-type-desc">
							{{ org.name }}
							{{
								$t('announcements_targetcount.variable', [orgCount], orgCount)
							}}
						</div>
					</div>
				</div>
				<div
					class="announcement-type"
					:class="{ active: type === types.GROUP }"
					@click="type = types.GROUP"
				>
					<UserGroupIcon halo type="solid" />
					<div class="announcement-type-details">
						<div
							class="announcement-type-title"
							v-text="$t('announcements_type_group_title')"
						/>
						<div
							class="announcement-type-desc"
							v-text="$t('announcements_type_group_subtitle')"
						/>
					</div>
				</div>
			</div>
		</div>
	</StandardModal>
</template>

<script>
import { getOrganization } from '@/store'
import { StandardModal, ProfilePic } from '@/components/common'
import { post } from '@/helpers/api'
import { UserGroupIcon } from '@/icons'

export const types = { ORG: 'org', GROUP: 'group' }

export default {
	name: 'AnnouncementTypeModal',
	components: { StandardModal, ProfilePic, UserGroupIcon },
	data() {
		return { type: null, types, orgCount: '--', org: getOrganization() }
	},
	mounted() {
		this.fetchOrgCount()
	},
	emits: ['change', 'close'],
	methods: {
		onContinue() {
			this.$emit('change', this.type)
			this.onClose()
		},
		onClose() {
			this.$emit('close')
		},
		async fetchOrgCount() {
			const org = getOrganization()
			try {
				const { data } = await post('/api/v1/announcement.targetcount', {
					targets: {
						organization_id: org.id,
					},
				})

				this.orgCount = data.targetcount
			} catch (e) {
				console.error(e)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.announcement-type-content {
	padding: 16px 24px;

	.announcement-type-heading {
		font-size: 18px;
		width: 100%;
		text-align: center;
		margin-bottom: 16px;
	}
	.announcement-types {
		@include flex-column(16px);
		width: 100%;

		.announcement-type {
			cursor: pointer;
			@include flex(16px);
			border: 1px solid var(--neutral-40040);
			border-radius: 6px;
			flex-shrink: 0;
			font-size: 15px;
			height: 62px;
			width: 100%;
			padding: 0 16px;

			&.active {
				color: var(--blue-300);
				border-color: var(--blue-300);
				background: var(--blue-100);
			}

			.announcement-type-details {
				@include flex-column(2px);
				.announcement-type-title {
					@include fontFamily(900);
					font-size: 16px;
				}
				.announcement-type-desc {
					font-size: 14px;
					color: var(--neutral-600);
				}
			}

			.pronto-icon {
				font-size: 17px;
				color: var(--blue-300);
			}
		}
	}
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.announcement-type-content {
		.announcement-type {
			&.active {
				background: var(--blue-300) !important;
				color: white !important;
				.pronto-icon {
					color: white !important;
				}
			}
		}
	}
}

@include overrideContrast {
	.announcement-type-content {
		.announcement-type {
			&.active {
				color: white !important;
				.announcement-type-desc {
					color: white !important;
				}
				.pronto-icon {
					color: white !important;
				}
			}
		}
	}
}
</style>
